import React from 'react';
import { connect } from 'react-redux';

import LodgingsComponent from './LodgingsComponent';
import { IAppState } from 'types/app';
import Props from './Props';

export function LodgingsContainer({
  description,
  image,
  name,
  owner,
}: Props) {
  if (!name) {
    return null;
  }
  return (
    <LodgingsComponent
      description={description}
      image={image}
      name={name}
      owner={owner}
    />
  );
}

LodgingsContainer.displayName = 'LodgingsContainer';

const mapStateToProps = ({
  myself: {
    character: {
      name: owner,
      currentDomicile: {
        description,
        image,
        name,
      },
    },
  },
}: IAppState) => ({
  description,
  image,
  name,
  owner,
});


export default connect(mapStateToProps)(LodgingsContainer);